<template>
  <div>
    <div>
      <h2 class="th-title">Maintenance Task Bulan {{ getHumanDate(selectedMonth) }}</h2>

      <a-month-picker
        v-model:value="selectedMonth"
        placeholder="Ganti bulan"
        class="mb-2"
        style="width: 200px;"
      />

      <a-button
        type="primary"
        class="ml-3"
        @click="generateTasksForMonth"
        :loading="isLoading"
        :disabled="allTasksForMonth.length"
      >
        Generate Task
      </a-button>

      <div v-if="!allTasksForMonth.length" class="mt-2">
        <p style="color: #F28585; margin-bottom: 10px;">
          Asset belum ditambahkan untuk user ini. Silahkan hubungi admin.
        </p>
      </div>
      <div class="mt-2">
        <p style="color: #B6BBC4; margin-bottom: 10px;">
          Pilih bulan dan klik "Generate Task" untuk membuat jadwal maintenance.
        </p>
      </div>
    </div>

    <a-tabs v-model:activeKey="activeTabKey">
      <a-tab-pane key="harian" tab="Harian">
        <div class="tab-content">
          <a-row :gutter="[16, 16]" class="mb-4 mt-4">
            <a-col :xs="24" :sm="12" :md="5"
              ><a-input-search
                v-model:value="searchQuery"
                placeholder="Cari Nama Item..."
                allow-clear
            /></a-col>

            <a-col :xs="24" :sm="12" :md="4">
              <a-date-picker
                v-model:value="selectedDailyDate"
                placeholder="Filter per Tanggal"
                style="width: 100%;"
                :disabled-date="disabledDailyDate"
              />
            </a-col>

            <a-col :xs="24" :sm="12" :md="4"
              ><a-select
                v-model:value="selectedCustomer"
                placeholder="Filter by Customer"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="customer in uniqueCustomers"
                  :key="customer"
                  :value="customer"
                  >{{ customer }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="4"
              ><a-select
                v-model:value="selectedLocation"
                placeholder="Filter by Location"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="location in uniqueLocations"
                  :key="location"
                  :value="location"
                  >{{ location }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="4"
              ><a-select
                v-model:value="selectedRoom"
                placeholder="Filter by Room"
                style="width: 100%;"
                allow-clear
                ><a-select-option v-for="room in uniqueRooms" :key="room" :value="room">{{
                  room
                }}</a-select-option></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="3"
              ><a-button @click="clearFilters" style="width: 100%;">Clear Filters</a-button></a-col
            >
          </a-row>
          <div>
            <a-table :columns="columns" :data-source="filteredData" :loading="isLoading" bordered>
              <template #name="{ text, record }"
                ><router-link
                  :to="{ path: `/monitoring/detail/${record.id}` }"
                  class="vb__utils__link"
                  >{{ text }}</router-link
                ></template
              >
              <template #action="{ record }">
                <div v-if="record.keterangan === 'Not Yet'">
                  <WarningFilled :style="{ color: 'firebrick' }" /> &nbsp;Belum dimulai
                </div>
                <div v-else-if="record.keterangan === 'Done'">
                  <CheckCircleOutlined :style="{ color: 'green' }" /> &nbsp;Selesai
                </div>
                <div v-else-if="record.keterangan === 'On Progress'">
                  <ClockCircleOutlined :style="{ color: '#FFF78A' }" /> &nbsp;On Progress
                </div>
              </template>
            </a-table>
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="bulanan" tab="Bulanan" force-render>
        <div class="tab-content">
          <a-row :gutter="[16, 16]" class="mb-4 mt-4">
            <a-col :xs="24" :sm="12" :md="6"
              ><a-input-search
                v-model:value="searchQuery"
                placeholder="Cari Nama Item..."
                allow-clear
            /></a-col>
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedCustomer"
                placeholder="Filter by Customer"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="customer in uniqueCustomers"
                  :key="customer"
                  :value="customer"
                  >{{ customer }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedLocation"
                placeholder="Filter by Location"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="location in uniqueLocations"
                  :key="location"
                  :value="location"
                  >{{ location }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedRoom"
                placeholder="Filter by Room"
                style="width: 100%;"
                allow-clear
                ><a-select-option v-for="room in uniqueRooms" :key="room" :value="room">{{
                  room
                }}</a-select-option></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="3"
              ><a-button @click="clearFilters" style="width: 100%;">Clear Filters</a-button></a-col
            >
          </a-row>
          <div>
            <a-table :columns="columns" :data-source="filteredData" :loading="isLoading" bordered>
              <template #name="{ text, record }"
                ><router-link
                  :to="{ path: `/monitoring/detail/${record.id}` }"
                  class="vb__utils__link"
                  >{{ text }}</router-link
                ></template
              >
              <template #action="{ record }">
                <div v-if="record.keterangan === 'Not Yet'">
                  <WarningFilled :style="{ color: 'firebrick' }" /> &nbsp;Belum dimulai
                </div>
                <div v-else-if="record.keterangan === 'Done'">
                  <CheckCircleOutlined :style="{ color: 'green' }" /> &nbsp;Selesai
                </div>
                <div v-else-if="record.keterangan === 'On Progress'">
                  <ClockCircleOutlined :style="{ color: '#FFF78A' }" /> &nbsp;On Progress
                </div>
              </template>
            </a-table>
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="3bulanan" tab="3 Bulan" force-render>
        <div class="tab-content">
          <a-row :gutter="[16, 16]" class="mb-4 mt-4">
            <a-col :xs="24" :sm="12" :md="6"
              ><a-input-search
                v-model:value="searchQuery"
                placeholder="Cari Nama Item..."
                allow-clear
            /></a-col>
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedCustomer"
                placeholder="Filter by Customer"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="customer in uniqueCustomers"
                  :key="customer"
                  :value="customer"
                  >{{ customer }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedLocation"
                placeholder="Filter by Location"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="location in uniqueLocations"
                  :key="location"
                  :value="location"
                  >{{ location }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedRoom"
                placeholder="Filter by Room"
                style="width: 100%;"
                allow-clear
                ><a-select-option v-for="room in uniqueRooms" :key="room" :value="room">{{
                  room
                }}</a-select-option></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="3"
              ><a-button @click="clearFilters" style="width: 100%;">Clear Filters</a-button></a-col
            >
          </a-row>
          <div>
            <a-table :columns="columns" :data-source="filteredData" :loading="isLoading" bordered>
              <template #name="{ text, record }"
                ><router-link
                  :to="{ path: `/monitoring/detail/${record.id}` }"
                  class="vb__utils__link"
                  >{{ text }}</router-link
                ></template
              >
              <template #action="{ record }">
                <div v-if="record.keterangan === 'Not Yet'">
                  <WarningFilled :style="{ color: 'firebrick' }" /> &nbsp;Belum dimulai
                </div>
                <div v-else-if="record.keterangan === 'Done'">
                  <CheckCircleOutlined :style="{ color: 'green' }" /> &nbsp;Selesai
                </div>
                <div v-else-if="record.keterangan === 'On Progress'">
                  <ClockCircleOutlined :style="{ color: '#FFF78A' }" /> &nbsp;On Progress
                </div>
              </template>
            </a-table>
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="6bulanan" tab="6 Bulan" force-render>
        <div class="tab-content">
          <a-row :gutter="[16, 16]" class="mb-4 mt-4">
            <a-col :xs="24" :sm="12" :md="6"
              ><a-input-search
                v-model:value="searchQuery"
                placeholder="Cari Nama Item..."
                allow-clear
            /></a-col>
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedCustomer"
                placeholder="Filter by Customer"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="customer in uniqueCustomers"
                  :key="customer"
                  :value="customer"
                  >{{ customer }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedLocation"
                placeholder="Filter by Location"
                style="width: 100%;"
                allow-clear
                ><a-select-option
                  v-for="location in uniqueLocations"
                  :key="location"
                  :value="location"
                  >{{ location }}</a-select-option
                ></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="5"
              ><a-select
                v-model:value="selectedRoom"
                placeholder="Filter by Room"
                style="width: 100%;"
                allow-clear
                ><a-select-option v-for="room in uniqueRooms" :key="room" :value="room">{{
                  room
                }}</a-select-option></a-select
              ></a-col
            >
            <a-col :xs="24" :sm="12" :md="3"
              ><a-button @click="clearFilters" style="width: 100%;">Clear Filters</a-button></a-col
            >
          </a-row>
          <div>
            <a-table :columns="columns" :data-source="filteredData" :loading="isLoading" bordered>
              <template #name="{ text, record }"
                ><router-link
                  :to="{ path: `/monitoring/detail/${record.id}` }"
                  class="vb__utils__link"
                  >{{ text }}</router-link
                ></template
              >
              <template #action="{ record }">
                <div v-if="record.keterangan === 'Not Yet'">
                  <WarningFilled :style="{ color: 'firebrick' }" /> &nbsp;Belum dimulai
                </div>
                <div v-else-if="record.keterangan === 'Done'">
                  <CheckCircleOutlined :style="{ color: 'green' }" /> &nbsp;Selesai
                </div>
                <div v-else-if="record.keterangan === 'On Progress'">
                  <ClockCircleOutlined :style="{ color: '#FFF78A' }" /> &nbsp;On Progress
                </div>
              </template>
            </a-table>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { notification } from 'ant-design-vue'
import { WarningFilled, ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons-vue'
import moment from 'moment'
import { generateTasks, getTasks, checkAssets } from '../../services/axios/modc/eos'

const columns = [
  { title: 'No', dataIndex: 'key', key: 'key' },
  {
    title: 'Nama Item',
    dataIndex: ['Asset', 'name'],
    key: 'name',
    slots: { customRender: 'name' },
  },
  {
    title: 'Kategori',
    dataIndex: ['Asset', 'AssetSubCategory', 'AssetCategory', 'name'],
    key: 'category',
  },
  { title: 'Sub-kategori', dataIndex: ['Asset', 'AssetSubCategory', 'name'], key: 'subCategory' },
  {
    title: 'Customers',
    dataIndex: ['Asset', 'Customer', 'name'],
    key: 'customers',
    sorter: (a, b) => a.Asset.Customer.name.localeCompare(b.Asset.Customer.name),
  },
  { title: 'Locations', dataIndex: ['Asset', 'Location', 'name'], key: 'locations' },
  { title: 'Rooms', dataIndex: ['Asset', 'Room', 'name'], key: 'rooms' },
  { title: 'Keterangan', key: 'ceklis', slots: { customRender: 'action' }, align: 'center' },
]

export default {
  components: {
    WarningFilled,
    ClockCircleOutlined,
    CheckCircleOutlined,
  },

  setup() {
    const store = useStore()
    const isLoading = ref(false)
    const allTasksForMonth = ref([])
    const selectedMonth = ref(moment())
    const activeTabKey = ref('harian')
    const isAssetAvailalble = ref(true)
    const selectedDailyDate = ref(null)
    const searchQuery = ref('')
    const selectedCustomer = ref(null)
    const selectedLocation = ref(null)
    const selectedRoom = ref(null)

    const fetchTasks = async () => {
      isLoading.value = true
      try {
        const storedUserData = localStorage.getItem('userData')
        if (!storedUserData) return
        const userData = JSON.parse(storedUserData)

        const targetMonth = selectedMonth.value
        const payload = {
          userId: userData.user.id,
          startDate: moment(targetMonth)
            .startOf('month')
            .format('YYYY-MM-DD'),
          endDate: moment(targetMonth)
            .endOf('month')
            .format('YYYY-MM-DD'),
        }

        const { tasks } = await getTasks({ params: payload })
        allTasksForMonth.value = tasks.map((e, idx) => ({ ...e, key: idx + 1 }))
      } catch (error) {
        console.error('Failed to fetch tasks:', error)
        notification.error({ message: 'Gagal memuat data task' })
      } finally {
        isLoading.value = false
      }
    }

    const generateTasksForMonth = async () => {
      isLoading.value = true
      try {
        const storedUserData = localStorage.getItem('userData')
        if (!storedUserData) return
        const userData = JSON.parse(storedUserData)

        const targetMonth = selectedMonth.value
        const payload = {
          userId: userData.user.id,
          month: moment(targetMonth).month() + 1,
          year: moment(targetMonth).year(),
        }

        await generateTasks(payload)
        notification.success({ message: 'Generate task berhasil!' })
        fetchTasks()
      } catch (error) {
        console.error('Failed to generate tasks:', error)
        const errorMessage = error.response?.data?.message || 'Generate task gagal!'
        notification.error({ message: errorMessage })
      } finally {
        isLoading.value = false
      }
    }

    const checkAsset = async () => {
      const storedUserData = localStorage.getItem('userData')
      if (!storedUserData) return
      const userData = JSON.parse(storedUserData)
      const { assetsCheck } = await checkAssets(userData.user.id)
      isAssetAvailalble.value = !assetsCheck
    }

    watch(selectedMonth, newValue => {
      if (newValue) {
        // selectedDailyDate.value = moment(newValue).startOf('month')
        selectedDailyDate.value = moment(selectedMonth.value).startOf('month')

        fetchTasks()
      }
    })

    const uniqueCustomers = computed(() => {
      if (!allTasksForMonth.value) return []
      const customers = allTasksForMonth.value
        .map(item => item.Asset?.Customer?.name)
        .filter(Boolean)
      return [...new Set(customers)]
    })

    const uniqueLocations = computed(() => {
      if (!allTasksForMonth.value) return []
      const locations = allTasksForMonth.value
        .map(item => item.Asset?.Location?.name)
        .filter(Boolean)
      return [...new Set(locations)]
    })

    const uniqueRooms = computed(() => {
      if (!allTasksForMonth.value) return []
      const rooms = allTasksForMonth.value.map(item => item.Asset?.Room?.name).filter(Boolean)
      return [...new Set(rooms)]
    })

    const filteredData = computed(() => {
      const cycleNameMap = {
        harian: 'Harian',
        bulanan: '1 Bulan',
        '3bulanan': '3 Bulan',
        '6bulanan': '6 Bulan',
      }
      const cycleNameToFilter = cycleNameMap[activeTabKey.value]

      let filtered = allTasksForMonth.value.filter(
        task => task.Asset?.MaintenanceCycle?.name === cycleNameToFilter,
      )

      if (activeTabKey.value === 'harian' && selectedDailyDate.value) {
        filtered = filtered.filter(task => moment(task.date).isSame(selectedDailyDate.value, 'day'))
      }

      if (searchQuery.value) {
        filtered = filtered.filter(item =>
          item.Asset?.name.toLowerCase().includes(searchQuery.value.toLowerCase()),
        )
      }
      if (selectedCustomer.value) {
        filtered = filtered.filter(item => item.Asset?.Customer?.name === selectedCustomer.value)
      }
      if (selectedLocation.value) {
        filtered = filtered.filter(item => item.Asset?.Location?.name === selectedLocation.value)
      }
      if (selectedRoom.value) {
        filtered = filtered.filter(item => item.Asset?.Room?.name === selectedRoom.value)
      }

      return filtered
    })

    // REVISI 3: Fungsi untuk menonaktifkan tanggal di luar bulan yang dipilih
    const disabledDailyDate = current => {
      if (!selectedMonth.value) {
        return false // Jika tidak ada bulan dipilih, jangan nonaktifkan apa pun
      }
      const startOfMonth = moment(selectedMonth.value).startOf('month')
      const endOfMonth = moment(selectedMonth.value).endOf('month')
      // Nonaktifkan jika tanggal 'current' berada di luar rentang bulan yang dipilih
      return current < startOfMonth || current > endOfMonth
    }

    const clearFilters = () => {
      searchQuery.value = ''
      selectedCustomer.value = null
      selectedLocation.value = null
      selectedRoom.value = null
      selectedDailyDate.value = null
    }

    onMounted(() => {
      selectedDailyDate.value = moment()

      fetchTasks()
      checkAsset()
    })

    return {
      isLoading,
      allTasksForMonth,
      selectedMonth,
      activeTabKey,
      generateTasksForMonth,
      filteredData,
      columns,
      isAssetAvailalble,
      searchQuery,
      selectedCustomer,
      selectedLocation,
      selectedRoom,
      uniqueCustomers,
      uniqueLocations,
      uniqueRooms,
      clearFilters,
      selectedDailyDate,
      disabledDailyDate, // Kirim fungsi ini ke template
    }
  },

  methods: {
    getHumanDate: function(date) {
      if (!date) return '...'
      return moment(date).format('MMMM YYYY')
    },
  },
}
</script>

<style scoped>
/* Anda bisa menambahkan styling di sini jika perlu */
.ml-3 {
  margin-left: 12px;
}
.mb-2 {
  margin-bottom: 8px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-4 {
  margin-top: 16px;
}
.tab-content {
  /* Memberi sedikit padding di dalam tab */
  padding: 0 8px;
}
</style>
